import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import VehicleDetail from 'core/layouts/vehicle-detail'
import * as routes from 'core/routing/constants/index'
import wizardsShape from 'core/components/wizard/shapes'
import { ButtonPrimary, ButtonGhost, Row, Col } from 'core/components/ui' //Row, Col,
import MainContentWrapper from 'core/templates/MainContentWrapper'

const StyledCol = styled(Col)`
  margin-bottom: 25px;
`

const Congratulations = props => {
  const { setLayoutModalInfo, intl, history, setWizards, wizards, vehicleTradeIn, vehicle } = props
  const aStepsActive = wizards[wizards.activeWizard]

  const activateFundingStep = () => {
    /*const { setWizards, wizards, history } = props
    const aStepsActive = wizards[wizards.activeWizard]

    const tradeInIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_TRADEIN)
    const fundingIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_FUNDING)

    const extendedStep = { ...aStepsActive[tradeInIndex], isActive: true }
    const extendedStep2 = { ...aStepsActive[fundingIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [tradeInIndex]: extendedStep,
      [fundingIndex]: extendedStep2
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)*/
    history.push(routes.CONFIGURATOR_FUNDING)
  }

  const activateFinalizationStep = () => {
    /* const { setWizards, wizards, history } = props

    const aStepsActive = wizards[wizards.activeWizard]

    const tradeInIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_TRADEIN)
    const fundingIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_FUNDING)
    const finalizationIndex = aStepsActive.findIndex(
      step => step.hash === routes.CONFIGURATOR_FINALIZATION
    )
    const extendedStep = { ...aStepsActive[tradeInIndex], isActive: true }
    const extendedStep2 = { ...aStepsActive[fundingIndex], isActive: true }
    const extendedStep3 = { ...aStepsActive[finalizationIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [tradeInIndex]: extendedStep,
      [fundingIndex]: extendedStep2,
      [finalizationIndex]: extendedStep3
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)*/
    history.push(routes.CONFIGURATOR_FINALIZATION)
  }

  const activeTradeInStep = () => {
    const nextIndex =
      aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_CONGRATULATIONS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)

    if (vehicleTradeIn) {
      const modalInfos = {
        showModal: true,
        title: intl.formatMessage({ id: 'configurator-modal-delete-tradein-title' }),
        content: intl.formatMessage({ id: 'configurator-modal-delete-tradein-content' }),
        route: extendedStep.hash
      }

      setLayoutModalInfo(modalInfos)
    } else {
      history.push(extendedStep.hash)
    }
  }

  useEffect(() => {
    const tradeInIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_TRADEIN)
    const fundingIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_FUNDING)
    const finalizationIndex = aStepsActive.findIndex(
      step => step.hash === routes.CONFIGURATOR_FINALIZATION
    )

    const extendedStep = { ...aStepsActive[tradeInIndex], isActive: true }
    const extendedStep2 = { ...aStepsActive[fundingIndex], isActive: true }
    const extendedStep3 = { ...aStepsActive[finalizationIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [tradeInIndex]: extendedStep,
      [fundingIndex]: extendedStep2,
      [finalizationIndex]: extendedStep3
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }, [])

  // first div => for animations
  return (
    <MainContentWrapper
      data-test="component-configurator-congratulations"
      title={intl.formatMessage({
        id: 'configurator-congratulations-view-title'
      })}
      subTitle={{
        subtitle: intl.formatMessage({
          id: 'configurator-congratulations-view-subtitle'
        })
      }}
    >
      <Row type="flex" justify="center">
        <Col lg={18} xs={24}>
          <VehicleDetail vehicle={vehicle} showDetails price={vehicle.price} />
        </Col>
        <Col lg={18} xs={24}>
          <Row type="flex" gutter={30} style={{ marginTop: '30px' }}>
            <StyledCol lg={7} xs={24}>
              <ButtonPrimary onClick={activeTradeInStep} block>
                <FormattedMessage id="configurator-congratulations-cta-1" />
              </ButtonPrimary>
            </StyledCol>
            <StyledCol lg={7} xs={24}>
              <ButtonGhost onClick={activateFundingStep} block>
                <FormattedMessage id="configurator-congratulations-cta-2" />
              </ButtonGhost>
            </StyledCol>

            <StyledCol lg={{ span: 7, offset: 3 }} xs={{ span: 24 }}>
              <ButtonGhost onClick={activateFinalizationStep} block>
                <FormattedMessage id="configurator-congratulations-cta-3" />
              </ButtonGhost>
            </StyledCol>
          </Row>
        </Col>
      </Row>
    </MainContentWrapper>
  )
}

Congratulations.defaultProps = {
  vehicleTradeIn: null,
  vehicle: null
}

Congratulations.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  vehicle: PropTypes.shape(),
  vehicleTradeIn: PropTypes.shape(),
  setLayoutModalInfo: PropTypes.func.isRequired,
  intl: PropTypes.shape().isRequired
}

export default withRouter(injectIntl(Congratulations))
